import React from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import authStore from '../store/authStore';

const Header: React.FC = observer(() => (
  <AppBar position="static" sx={{ zIndex: 1201 }}>
    <Toolbar>
      <img src="/favicon.ico" alt="logo" style={{ width: 32, marginRight: 16 }} />
      <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
        AdSpace Admin
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {authStore.isAuthenticated ? (
          <>
            <IconButton color="inherit" onClick={() => authStore.logout()}>
              <LogoutIcon />
            </IconButton>
            <Typography
              variant="body1"
              sx={{ ml: 1, cursor: 'pointer' }}
              onClick={() => authStore.logout()}
              color="inherit"
            >
              Logout
            </Typography>
          </>
        ) : (
          <>
            <IconButton color="inherit" component={Link} to="/">
              <LoginIcon />
            </IconButton>
            <Typography
              variant="body1"
              sx={{ ml: 1, cursor: 'pointer' }}
              component={Link}
              to="/"
              color="inherit"
            >
              Login
            </Typography>
          </>
        )}
      </Box>
    </Toolbar>
  </AppBar>
));

export default Header;